import { ArrowDown, ArrowRight } from 'react-feather';
import { Card as CommonCard } from 'components/common/Card';
import FlexContainer from 'components/common/FlexContainer';
import { backgroundStyles } from 'styles/theme';
import { mobileMediaQuery } from 'utils/common';
import styled from '@emotion/styled';
import useIsMobile from 'hooks/use-is-mobile';

export const Card = styled(CommonCard)({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: 24,
  justifyItems: 'center',
  border: 'none',
  [mobileMediaQuery]: {
    margin: '0px 20px',
    flexDirection: 'column',
  },
});
export const ArrowContainer = styled(FlexContainer)({
  width: 58,
  height: 58,
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  border: `1px solid ${backgroundStyles.colors.tertiary}`,
  [mobileMediaQuery]: {
    width: 32,
    height: 32,
  },
});

export function ArrowSection(): JSX.Element {
  const isMobile = useIsMobile();
  return (
    <ArrowContainer className='precedent-details-arrow-container'>
      {isMobile ? <ArrowDown size={16} /> : <ArrowRight size={24} />}
    </ArrowContainer>
  );
}
